import React, { useRef, lazy } from 'react';
import { motion, useInView } from 'framer-motion';
const images = [{
  src: 'https://cdn.magicpatterns.com/uploads/8iD82aMZDaV5HYXRLTYfEw/prodej-novostavby-v-nejvyssim-podlazi-s-velkou-terasou-a-2-balkony-obyvak-d3087d_(1).jpg',
  alt: 'Světlý obývací pokoj s dřevěnou podlahou a výhledem',
  className: 'col-span-1 md:col-span-2 row-span-2'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/joWef9kUcnJ4CCcnDzJUvV/prodej-novostavby-v-nejvyssim-podlazi-s-velkou-terasou-a-2-balkony-loznice-a0ca5a_(1).jpg',
  alt: 'Prostorná ložnice s dřevěnými prvky a velkým oknem',
  className: 'col-span-1 row-span-1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/c3K3zTCsGJbsTHmdVpgDh2/prodej-novostavby-v-nejvyssim-podlazi-s-velkou-terasou-a-2-balkony-koupelna-b22b75.jpg',
  alt: 'Moderní koupelna s podsvíceným zrcadlem a dřevěným dekorem',
  className: 'col-span-1 row-span-1'
}];
export function PhotoGallery() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const isInView = useInView(sectionRef, {
    once: true,
    margin: '-80px'
  });
  return <section id="gallery" ref={sectionRef} className="w-full bg-villa-dark py-24 md:py-32 px-6 md:px-10 transition-colors duration-500" aria-label="Fotogalerie" data-id="element-132">
      <div className="max-w-7xl mx-auto" data-id="element-133">
        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="text-villa-gold text-[12px] tracking-[0.3em] uppercase font-inter font-light mb-6" data-id="element-134">
          Vizualizace
        </motion.p>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        delay: 0.1,
        ease: 'easeOut'
      }} className="font-playfair text-villa-text text-3xl md:text-4xl lg:text-5xl font-medium mb-14 leading-tight" data-id="element-135">
          Návrh interiéru
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 auto-rows-[300px] md:auto-rows-[350px]" data-id="element-136">
          {images.map((image, i) => <motion.div key={image.src} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.7,
          delay: 0.15 + i * 0.1,
          ease: 'easeOut'
        }} className={`overflow-hidden ${image.className}`} data-id="element-137">
              <img src={image.src} alt={image.alt} className="w-full h-full object-cover transition-transform duration-700 ease-out hover:scale-105 cursor-pointer" loading="lazy" data-id="element-138" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}